export default {
  volume: "卷",
  volumeName: "卷名",
  volumePath: "宿主机路径",
  volumeMountPath: "容器内挂载路径"
};
